// src/utils/rpc-error.ts
var TRANSPORT_ERROR_NAMES = /* @__PURE__ */ new Set(["CallRequestTransportError", "CallRequestTransportTimeoutError"]);
function readResponse(err) {
	if (!err || typeof err !== "object") return void 0;
	const { response } = err;
	return response && typeof response === "object" ? response : void 0;
}
function normalizeRpcError(err) {
	const response = readResponse(err);
	const name = err?.name;
	const isTransportError = typeof name === "string" && TRANSPORT_ERROR_NAMES.has(name);
	const code = typeof response?.code === "number" ? response.code : 0;
	let detail = "";
	if (typeof response?.message === "string" && response.message) detail = response.message;
	else if (err instanceof Error) detail = err.message;
	else if (err !== void 0 && err !== null) detail = String(err);
	const browserOffline = typeof navigator !== "undefined" && navigator.onLine === false;
	return {
		code,
		detail: detail || "Unknown error",
		offline: isTransportError || code === 0 && browserOffline
	};
}
export { normalizeRpcError };

//# sourceMappingURL=rpc-error.js.map